import axios from "axios"
import { UserAuth } from "../config/data.types";

const sessaoApi = async () => {
    const url = `${process.env.PARCEL_API_URL}`

    let userString = localStorage.getItem("credencial");
    let passString = localStorage.getItem("credencial_pass");
    let userObj: UserAuth = JSON.parse(userString!);
    let pass = atob(passString!);

    const auth = Buffer.from(`${userObj.name}:${pass}`).toString("base64")

    const api = axios.create({
        baseURL: url,
        headers: {
            "Authorization": `Basic ${auth}`,
            "Content-Type": "application/json",
        },
        
    })

    let response = await api.get("/")
    return response.data
}

interface FiltroAtendimentoApi {
    situacao: "ativo" | "inativo" | "todos",
    status: "todos" | "em_dia" | "atrasado",
    dtIni: string,
    dtFim: string,
}
const getAtendimentos = async (props:FiltroAtendimentoApi) => {
    const url = `${process.env.PARCEL_API_URL}`

    const api = axios.create({
        baseURL: url,
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            situacao: props.situacao,
            status: props.status,
            dtIni: props.dtIni,
            dtFim: props.dtFim,
        }
    })

    let response = await api.get("/atendimentos")
    if(response.data.status !== "ok"){
        let respSessao = await sessaoApi()
        if(respSessao.status === "ok"){
            response = await api.get("/atendimentos")
        }
    }
    return response.data
}

export {
    sessaoApi,
    getAtendimentos,
    type FiltroAtendimentoApi
}